import { extendTheme } from '@chakra-ui/react';
import { ColorModeOptions } from '@chakra-ui/system';

import components from './components';
import foundations from './foundations';
import styles from './styles';

/**
 * Color mode config
 */
const config: ColorModeOptions = {
  useSystemColorMode: false,
  initialColorMode: 'dark',
};

const theme = extendTheme({
  ...foundations,
  components,
  styles,
  config,
});

export type Theme = typeof theme;

export default theme;
